var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6999 18L13.5999 8.90001C14.4999 6.60001 13.9999 3.90001 12.0999 2.00001C10.0999 1.20401e-05 7.09994 -0.399988 4.69994 0.700012L8.99994 5.00001L5.99994 8.00001L1.59994 3.70001C0.399939 6.10001 0.899939 9.10001 2.89994 11.1C4.79994 13 7.49994 13.5 9.79994 12.6L18.8999 21.7C19.2999 22.1 19.8999 22.1 20.2999 21.7L22.5999 19.4C23.0999 19 23.0999 18.3 22.6999 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadFile);
export default __webpack_public_path__ + "static/media/threadFile.2d30d49b5359064161acd86dd300cc1f.svg";
export { ForwardRef as ReactComponent };